import classNames from "classnames";
import useAppModernisation from "../../hooks/useAppModernisation";
import style from "./GuidelineChip.module.scss";
import icons from "../../scss/guidelineicons.module.scss";

const GuidelineChip = ({ iconClassSuffix, linkText, onClickProps, showArrowIcon = true }) => {
  const { isAppMode } = useAppModernisation();

  const appGuidelineNavigation = (guideline) => {
    const normalizeGuideline = guideline.replaceAll(" ", "_");
    // change to page reload to remove state from guideline nav page
    window.location.href = `/app/nav/${normalizeGuideline}`;
  };

  const webGuidelineNavigation = (guideline) => {
    const normalizeGuideline = guideline.replaceAll(" ", "_");
    // change to page reload to remove state from guideline nav page
    window.location.href = `/guidelines/${normalizeGuideline}`;
  };

  if (linkText === "Drug use in pregnancy and breastfeeding") {
    linkText = "Pregnancy and breastfeeding";
  }

  return (
    <span className={style.guidelineChip} role="button" aria-label={`${linkText}-breadcrumb`}>
      <span className={classNames(icons[iconClassSuffix], style.guidelineIcon)} />
      <span
        className={classNames("size-14", style.guidelineChipText)}
        aria-label={linkText}
        onClick={() => {
          isAppMode ? appGuidelineNavigation(onClickProps) : webGuidelineNavigation(onClickProps);
        }}
      >
        {linkText}
        {showArrowIcon && (
          <span className="goto-arrow">
            <i className="fa banner-head-topic fa-angle-right" />
          </span>
        )}
      </span>
    </span>
  );
};

export default GuidelineChip;
